import { Directive } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn
} from '@angular/forms';
import * as bigInt from 'big-integer';

// Validation Function
function validateIBANFactory(): ValidatorFn {
  return (c: AbstractControl) => {
    if (c.value) {
      // Remove spaces
      let iban = c.value.toUpperCase().replace(/\s/g, '');

      // Move first 4 characters
      iban = iban.substring(4) + iban.substring(0, 4);

      // Replace Letters
      iban = ReplaceCharacters(iban);

      // Calculate Rest
      const rest = bigInt(iban).mod(97);

      // Check
      const isValid = rest.toJSNumber() === 1;

      if (isValid) {
        return null;
      } else {
        return {
          IBAN: true
        };
      }
    } else {
      return null;
    }
  };
}

function ReplaceCharacters(iban: string): string {
  let result = '';
  for (let x = 0; x < iban.length; x++) {
    const ascii = iban.charCodeAt(x);
    if (ascii > 64 && ascii < 91) {
      result += ascii - 55;
    } else {
      result += iban.charAt(x);
    }
  }

  return result;
}

@Directive({
  selector: '[appIBAN][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: IbanValidatorDirective, multi: true }]
})
export class IbanValidatorDirective implements Validator {
  validator: ValidatorFn;

  constructor() {
    this.validator = validateIBANFactory();
  }

  validate(c: FormControl): ValidationErrors | null {
    return this.validator(c);
  }
}
